import React from "react";

import { Form, Input, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";
import { accountType } from "../../../../utils/Util";
const { Option } = Select;

function BankAccounts({ bankAccounts, setBankAccounts }) {
  const addBankAccounts = () => {
    const newBankAccounts = {
      id: uuidv4(),
      name: "",
      accountType: "",
      accountNumber: "",
      balance: "",
    };
    setBankAccounts([...bankAccounts, newBankAccounts]);
  };

  const removeBankAccounts = (id) => {
    const updatedBankAccounts = bankAccounts.filter((item) => item.id !== id);
    setBankAccounts(updatedBankAccounts);
  };

  const handleChange = (value, name, id) => {
    const updatedBankAccounts = bankAccounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setBankAccounts(updatedBankAccounts);
  };

  return (
    <ul>
      {bankAccounts.map((item, index) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={6}>
                <Form.Item
                  label="  "
                  rules={[
                    {
                      required: true,
                      message: "Please enter your last name!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Name"
                    onChange={(e) =>
                      handleChange(e.target.value, "name", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="" name={`bankAccType${index}`}>
                  <Select
                    onChange={(value) =>
                      handleChange(value, "accountType", item.id)
                    }
                  >
                    {accountType.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.value}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="" name={`bankAccNum${index}`}>
                  <Input
                    placeholder="Account Number"
                    onChange={(e) =>
                      handleChange(e.target.value, "accountNumber", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="" name={`bankAccBalance${index}`}>
                  <Input
                    placeholder="Balance"
                    prefix="$"
                    onChange={(e) =>
                      handleChange(e.target.value, "balance", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {bankAccounts.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeBankAccounts(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addBankAccounts}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Bank Account
        </Button>
      </Form.Item>
    </ul>
  );
}

export default BankAccounts;
